export default __webpack_public_path__ + "static/media/to_delete15.35216901.svg";